// This file is generated by a script and should not be modified directly.
const markdown: string = "Adresse postale et géolocalisation rattachées au numéro SIRET de l’entreprise\n"
export default markdown
